export const hoverColor = "#f3f2f2"
export const naturalColor = "#ffffff"
export const hoverFontColor = "#3196e6"
export const naturalFontColor = "#878c9c"